/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SearchProductForDsaFieldsFragment = {
  __typename?: 'ChannelOffer';
  sku: {
    __typename?: 'ChannelOfferSku';
    masterProduct: {
      __typename?: 'ChannelOfferSkuMasterProduct';
      brand?: { __typename?: 'ChannelBrand'; title: string };
    };
  };
  seller: { __typename?: 'OfferSeller'; contractName?: string };
};

export type DsaByProductIdQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  productId: Types.Scalars['String']['input'];
}>;

export type DsaByProductIdQuery = {
  __typename?: 'Query';
  product?: {
    __typename?: 'ChannelOffer';
    sku: {
      __typename?: 'ChannelOfferSku';
      masterProduct: {
        __typename?: 'ChannelOfferSkuMasterProduct';
        brand?: { __typename?: 'ChannelBrand'; title: string };
      };
    };
    seller: { __typename?: 'OfferSeller'; contractName?: string };
  };
};

export const SearchProductForDsaFieldsFragmentDoc = /*#__PURE__*/ `
    fragment SearchProductForDSAFields on ChannelOffer {
  sku {
    masterProduct {
      brand {
        title
      }
    }
  }
  seller {
    contractName
  }
}
    `;
export const DsaByProductIdDocument = /*#__PURE__*/ `
    query DSAByProductId($platform: Platform!, $market: Market!, $productId: String!) {
  product: offerByProductId(
    productId: $productId
    saleChannel: {market: $market, platform: $platform}
  ) {
    ...SearchProductForDSAFields
  }
}
    ${SearchProductForDsaFieldsFragmentDoc}`;

export function useDsaByProductIdQuery(
  options: Omit<Urql.UseQueryArgs<DsaByProductIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<DsaByProductIdQuery, DsaByProductIdQueryVariables>({
    query: DsaByProductIdDocument,
    ...options,
  });
}
